export const GENDERS = ['Male', 'Female', 'Other'];

export const PAYMENT_MODES = [
  { value: '1', label: 'Bank Transfer' },
  { value: '2', label: 'UPI' },
  { value: '3', label: 'Both' },
];

export const RATING_OPTIONS = ['1', '2', '3', '4', '5'];

export const DEFAULTS = {
  rating: '3',
  room_count: '1',
  hotel_percentage: '15',
  payment_mode: '1',
};

export const HOST_OWNER_FIELDS = [
  { key: 'hostName', label: 'Host Name', type: 'text', required: true, placeholder: 'Full name of the host', maxLength: 100, icon: 'user' },
  { key: 'hostEmail', label: 'Host Email', type: 'email', required: true, placeholder: 'host@email.com', maxLength: 100, icon: 'envelope' },
  { key: 'hostPhone', label: 'Host Phone', type: 'tel', required: true, placeholder: '10-digit mobile number', maxLength: 15, icon: 'phone' },
  { key: 'hostGender', label: 'Host Gender', type: 'select', required: true, placeholder: 'Select gender', options: GENDERS, icon: 'user' },
  { key: 'hotelOwnerFullName', label: 'Property Owner Full Name', type: 'text', required: true, placeholder: 'Legal name of the owner', maxLength: 100, icon: 'user' },
  { key: 'hotelOwnerMobileNumber', label: 'Owner Mobile Number', type: 'tel', required: true, placeholder: '10-digit mobile number', maxLength: 15, icon: 'phone' },
  { key: 'aadharCardNumber', label: 'Aadhaar Card Number', type: 'text', required: true, placeholder: '12-digit Aadhaar number', maxLength: 12, icon: 'id-card' },
  { key: 'password', label: 'Password', type: 'password', required: true, placeholder: 'Min 6 characters', maxLength: 40, icon: 'lock' },
  { key: 'confirmPassword', label: 'Confirm Password', type: 'password', required: true, placeholder: 'Re-enter password', maxLength: 40, icon: 'lock' },
  { key: 'rating', label: 'Property Rating (stars)', type: 'select', required: true, options: RATING_OPTIONS, icon: 'star' },
  { key: 'roomCount', label: 'Room Count', type: 'number', required: true, placeholder: '1', maxLength: 5, icon: 'bed' },
];

export const FIELD_MAP = {
  propertyName: 'hotel_name',
  selectedPropertyType: 'type',
  city: 'city_name',
  state: 'state_name',
  country: 'country_name',
  pincode: 'pincode',
  latitude: 'latitude',
  longitude: 'longitude',
  propertyDescription: 'description',
  phoneNumber: 'phone',
  email: 'email',
  checkinTime: 'check_in_time',
  checkoutTime: 'check_out_time',
  selectedAmenities: 'amenities',
  selectedHotelPolicies: 'hotel_policy',
  selectedCancellationPolicies: 'cancellation_policy',
  isOpen24x7: 'open_24_7',
  isCoupleFriendly: 'is_couple_allowed',
  bankName: 'bank_name',
  ifscCode: 'ifsc_code',
  accountNumber: 'account_number',
  accountHolderName: 'account_holder_name',
  panNumber: 'pan_number',
  gstNumber: 'gst_number',
  paymentMode: 'payment_mode',
  hostName: 'host_name',
  hostEmail: 'host_email',
  hostPhone: 'host_phone',
  hostGender: 'host_gender',
  hotelOwnerFullName: 'hotel_owner_full_name',
  hotelOwnerMobileNumber: 'hotel_owner_mobile_number',
  aadharCardNumber: 'aadhar_card_number',
  password: 'password',
  confirmPassword: 'confirm_password',
  rating: 'rating',
  roomCount: 'room_count',
};

export const SUPPORT_CONTACT = {
  phoneDisplay: '+91 7082828181',
  phoneHref: 'tel:+917082828181',
  email: 'support@tabtrips.com',
};

/**
 * Same section keys the dashboard Property Images page posts to updateImage
 * as `<key>[]`. Room-type sections are omitted: room types are still pending
 * approval when a listing is created, so their section keys don't exist yet.
 */
export const HOTEL_IMAGE_SECTIONS = [
  { key: 'main_image', label: 'Main Image', multiple: false, min: 1, hint: 'Cover photo guests see first. One image.' },
  { key: 'hotel_images', label: 'Property Images', multiple: true, min: 5, hint: 'Exterior, common areas, facilities and surroundings. At least 5 images.' },
];

/**
 * KYC / compliance image sections uploaded via updateImage once the property exists.
 * pan_card_photo is a single-file (replace) category; gst_photo already
 * exists on the backend and is single-file too.
 */
export const KYC_IMAGE_SECTIONS = [
  { key: 'pan_card_photo', label: 'PAN Card Photo', multiple: false, hint: 'Photo of your PAN card. Required if no GST number.' },
  { key: 'gst_photo', label: 'GST Certificate Photo', multiple: false, hint: 'Photo of your GST certificate. Required if no PAN number.' },
];

export const MIN_MAIN_IMAGES = 1;
export const MIN_PROPERTY_IMAGES = 5;
